import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default function TooltipCell({color, children}) {
  const className = classnames('tooltip-cell', {[`is-color-${color}`]: color})

  return <div className={className}>{children}</div>
}

TooltipCell.propTypes = {
  color: PropTypes.oneOf(['white'])
}



// WEBPACK FOOTER //
// ./client/components/Tooltip/TooltipCell.js